var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"he-plugin"},[_c('div',{staticClass:"weather"},[_c('div',{staticClass:"temp"},[_vm._v(_vm._s(_vm.temp)+"℃")]),_c('div',{staticClass:"status"},[_vm._v(_vm._s(_vm.status))])]),_c('img',{staticClass:"icon",attrs:{"src":`https://cdn.gongjiangyi.com/he/128/${_vm.icon}.png`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }